import React, { useEffect, useState } from 'react';
import { useSearchParams } from 'react-router-dom';
import axios from 'axios'; // Direct axios import to avoid encryption

const DownloadWeAll = () => {
  const [searchParams] = useSearchParams();
  const [content, setContent] = useState('');
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState('');

  useEffect(() => {
    const token = searchParams.get('token');
    
    if (!token) {
      setError('Token is required');
      setLoading(false);
      return;
    }

    const fetchContent = async () => {
      try {
        // Build the API URL with fallbacks
        const apiUrl = `${process.env.REACT_APP_API_URL || 'http://localhost:5558'}${process.env.REACT_APP_API_PATH || '/api'}${process.env.REACT_APP_API_VERSION || '/v1'}${process.env.REACT_APP_API_MOBILE || '/mobile'}/auth/password-reset-redirect?token=${token}`;
        
        // Make the API call with direct axios (no encryption)
        const response = await axios.get(apiUrl, {
          headers: {
            'Content-Type': 'text/html',
            'Accept': 'text/html,application/xhtml+xml,application/xml;q=0.9,image/webp,*/*;q=0.8'
          },
          responseType: 'text' // Important for HTML response
        });
        
        // Set the HTML content
        setContent(response.data);
        setLoading(false);
      } catch (err) {
        console.error('Error fetching content:', err);
        console.error('Error response:', err.response?.data);
        setError('Failed to load content. Please try again.');
        setLoading(false);
      }
    };

    fetchContent();
  }, [searchParams]);

  if (loading) {
    return (
      <div style={{ 
        display: 'flex', 
        justifyContent: 'center', 
        alignItems: 'center', 
        height: '100vh',
        backgroundColor: 'white'
      }}>
        <div>Loading...</div>
      </div>
    );
  }

  if (error) {
    return (
      <div style={{ 
        display: 'flex', 
        justifyContent: 'center', 
        alignItems: 'center', 
        height: '100vh',
        backgroundColor: 'white',
        color: 'red',
        textAlign: 'center',
        padding: '20px'
      }}>
        <div>
          <h2>Error</h2>
          <p>{error}</p>
        </div>
      </div>
    );
  }

  return (
    <div style={{ backgroundColor: 'white', minHeight: '100vh' }}>
      {/* Render the HTML content safely */}
      <div 
        dangerouslySetInnerHTML={{ __html: content }}
        style={{ minHeight: '100vh' }}
      />
    </div>
  );
};

export default DownloadWeAll;
